export default __webpack_public_path__ + "static/media/KP.37f2277f.svg";